import type { HeadInfo } from '~~/modules/head/entities/HeadInfo'
import decoratorCottageToHeadInfo from '~~/modules/views/cottage-prices/utils/decoratorCottageToHeadInfo'
import { useHeadInfoComposable } from '~~/modules/head/composables/useHeadInfoComposable'
import decoratorCottageToMenuBreadcrumb from '~~/modules/views/cottage-prices/utils/decoratorCottageToMenuBreadcrumb'
import { useMenuBreadcrumbStore } from '~~/modules/menu/stores/useMenuBreadcrumbStore'
import type { Cottage } from '~~/modules/views/cottage-prices/entities/Cottage'

export const usePageConfiguration = (cottagePricesPage: Cottage) => {
  const { setHeadInfo } = useHeadInfoComposable()
  const cottageHeadInfo: HeadInfo = decoratorCottageToHeadInfo(
    cottagePricesPage,
    {
      // TODO: change when the page in nuxt-pages dies
      robotsVisible: false,
    },
  )
  setHeadInfo(cottageHeadInfo)
  const cottageMenuBreadcrumb =
    decoratorCottageToMenuBreadcrumb(cottagePricesPage)
  const breadCrumbMenuStore = useMenuBreadcrumbStore()
  breadCrumbMenuStore.setMenuBreadcrumb(
    t('views.cottage-prices.breadcrumb.prices'),
    cottageMenuBreadcrumb,
  )
}
